var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow":"auto"}},[_c('span',{domProps:{"innerHTML":_vm._s(
      _vm.transformHtml(
        _vm.convertAnswerText(
          _vm.row.questionDetails && (_vm.row.questionDetails.content.richText || _vm.row.questionDetails.content.text),
          _vm.answerContent
        )
      )
    )}}),(_vm.row && _vm.row.activePhotoFiles)?_c('show-files',{attrs:{"img-data":_vm.row.activePhotoFiles}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }